import React from 'react';
import styled from 'styled-components';
import {
  func
} from 'prop-types';

import ConfirmationDialog from './ConfirmationDialog';

const Wrapper = styled.div`
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;

`;

const Overlay = styled.div`
  width: 100%;
  height: 100%;

  overflow-y: auto;

  transition: all 0.2s linear;
`;

const Modal = styled.div`
  position: absolute;
  top: 0; left: 0; width: 100%; height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  overflow: auto;

  transition: background-color 0.2s linear, opacity 0.2s linear;
  opacity: ${({ open }) => open ? '1' : '0'};
  pointer-events: ${({ open }) => open ? 'unset' : 'none'};
  background-color: ${({ open }) => open ? 'rgba(0,0,0,0.25)' : 'rgba(0,0,0,0)'};
  &>div {
    transition: transform 0.2s ease-in-out;
    transform: scale(${({ open }) => open ? '1' : '0.9'});
  }
  user-select: none;
`;

class ModalProvider extends React.Component {
  constructor() {
    super();

    this.state = {
      open: false,
      component: undefined,
      modalProps: undefined,
      options: {}
    };
  }
  static childContextTypes = {
    openModal: func,
    closeModal: func,
    setModalContent: func,
    confirm: func,
    prompt: func
  };
  componentDidMount() {
    window.addEventListener('keyup', this.handleKeyUp);
  }
  componentWillUnmount() {
    window.removeEventListener('keyup', this.handleKeyUp);
  }
  confirm = (message, props = {}) => new Promise((resolve, reject) => {
    this.openModal(ConfirmationDialog, {
      message,
      ...props,
      confirm: (value) => {
        this.closeModal();
        resolve(value);
      },
      cancel: () => {
        this.closeModal();
        reject();
      }
    }, { noOutsideClick: true });
  });
  handleKeyUp = (e) => {
    if (e.which === 27) {
      this.closeModal();
    }
  };
  getChildContext() {
    return {
      openModal: (Component, props, options) => this.openModal(Component, props, options),
      closeModal: () => this.closeModal(),
      setModalContent: (Component, props) => this.setModalContent(Component, props),
      confirm: (message, props) => this.confirm(message, props),
      prompt: (message, props = {}) => this.confirm(message, { input: true, ...props })
    };
  }
  openModal = (component, props, options) => {
    clearTimeout(this.timeout);
    
    this.setState({
      open: true,
      component: component,
      modalProps: props,
      options: options || {}
    });
  };
  closeModal = () => {
    this.setState({
      open: false
    });

    this.timeout = setTimeout(() => {
      this.setState({ component: undefined, modalProps: undefined });
    }, 200);
  };
  setModalContent = (component, props, options) => {
    this.setState({
      component: component,
      modalProps: props
    });
  };
  handleOverlayClicked = () => {
    if (this.state.open && !this.state.options.noOutsideClick) {
      this.closeModal();
    }
  };
  diffuseClick = (e) => {
    e.stopPropagation();
  };
  render() {
    const { component: ModalContent, modalProps, open } = this.state;
    return (
      <Wrapper>
        <Overlay open={open}>
          {this.props.children}
        </Overlay>
        <Modal onClick={this.handleOverlayClicked} open={open}>
          {ModalContent && (<ModalContent { ...modalProps } onClick={this.diffuseClick} />)}
        </Modal>
      </Wrapper>
    );
  }
}

export default ModalProvider;


// WEBPACK FOOTER //
// ./src/components/Modals/ModalProvider.js